import $ from "jquery";
import "jquery-validation";
import "jquery-validation/dist/additional-methods.js";
import "magnific-popup";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

$(function () {
  articleCarousel();
  articleSlider();
  categoryMobileMenu();
  categorySearchForm();
  brandMobileMenu();
  cartAddArticle();
  cartUpdateOrRemoveArticle();
  formValidate();
  formUpload();
  formRegister();
  formProfile();
  popupHandler();
  profileDropdown();
  searchForm();
  shippingAddressCopy();
  paymentHandler();
});

//

function articleCarousel() {
  $(".article-carousel").each(function () {
    const $this = $(this);
    const $swiper = $this.find(".swiper");
    const $prevBtn = $this.find(".swiper-button-prev");
    const $nextBtn = $this.find(".swiper-button-next");

    new Swiper($swiper[0], {
      modules: [Navigation],
      slidesPerView: 2,
      spaceBetween: 8,
      navigation: {
        nextEl: $nextBtn[0],
        prevEl: $prevBtn[0],
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    });
  });
}

function articleSlider() {
  $(".article-view-slider").each(function () {
    const $swiper = $(this);
    const $prevBtn = $swiper.find(".swiper-button-prev");
    const $nextBtn = $swiper.find(".swiper-button-next");

    new Swiper($swiper[0], {
      modules: [Navigation],
      navigation: {
        nextEl: $nextBtn[0],
        prevEl: $prevBtn[0],
      },
    });
  });
}

function categoryMobileMenu() {
  const $open = $(".category-view-mobile-open");
  if (!$open.length) return;
  const $body = $("body");
  const $menu = $(".category-view-mobile-menu");
  const $backdrop = $menu.find(".category-view-mobile-backdrop");
  const $panel = $menu.find(".category-view-mobile-panel");
  const $close = $(".category-view-mobile-close");

  $open.on("click", function () {
    $body.addClass("overflow-hidden");
    $menu.attr("data-active", "true");

    setTimeout(function () {
      $backdrop.attr("data-active", "true");
      $panel.attr("data-active", "true");
    }, 200);
  });

  $close.add($backdrop).on("click", function () {
    $panel.attr("data-active", "false");
    $backdrop.attr("data-active", "false");

    setTimeout(function () {
      $menu.attr("data-active", "false");
      $body.removeClass("overflow-hidden");
    }, 200);
  });
}

function categorySearchForm() {
  const $form = $(".category-view-search-form");
  if (!$form.length) return;
  const $loadingOverlay = $(".category-view-loading-overlay").add(
    $form.find(".category-view-search-form-overlay"),
  );

  $form.each(function () {
    const $form = $(this);
    const $links = $form.find("a");
    const $checks = $form.find("input[type=checkbox]");

    $links.on("click", function (e) {
      e.preventDefault();
      $loadingOverlay.removeClass("hidden");
      $links.filter("[data-active=true]").attr("data-active", "false");
      const $this = $(this).attr("data-active", "true");
      setTimeout(function () {
        window.location.href = $this.attr("href");
      }, 500);
    });

    $checks.on("change", function () {
      $loadingOverlay.removeClass("hidden");
      setTimeout(function () {
        $form[0].submit();
      }, 500);
    });
  });
}

//

function brandMobileMenu() {
  const $toggle = $(".brand-view-mobile-toggle");
  if (!$toggle.length) return;
  const $menu = $(".brand-view-menu");

  $toggle.on("click", function () {
    const active = $menu.attr("data-active") === "true";
    $menu.attr("data-active", active ? "false" : "true");
  });
}

//

function cartAddArticle() {
  const $addBtn = $("button[data-on=article-add-to-cart]");
  if (!$addBtn.length) return;
  const $loadingOverlay = $(".article-view-loading-overlay");

  $addBtn.on("click", function () {
    const action = $addBtn.attr("data-action");
    const data = {
      articleCode: $addBtn.attr("data-code"),
      qty: 1,
      wosid: $addBtn.attr("data-wosid"),
    };

    $loadingOverlay.removeClass("hidden");
    $.post(action, data).done((url) => {
      setTimeout(() => {
        appendTimestampAndNavigateTo(url);
      }, 500);
    });
  });
}

function cartUpdateOrRemoveArticle() {
  const $qtys = $(".cart-view-input-qty");
  if (!$qtys.length) return;
  const $loadingOverlay = $(".cart-view-loading-overlay");

  $qtys.on("change", function (e) {
    const $qty = $(this);
    const $updateBtn = $qty.siblings(".cart-view-update-btn");

    const action = $updateBtn.attr("data-action");
    const data = {
      articleCode: $updateBtn.attr("data-code"),
      qty: parseInt($qty.val()),
      wosid: $updateBtn.attr("data-wosid"),
    };

    $loadingOverlay.removeClass("hidden");
    $.post(action, data).done((url) => {
      setTimeout(() => {
        appendTimestampAndNavigateTo(url);
      }, 500);
    });
  });

  //

  const $removeBtns = $(".cart-view-remove-btn");
  $removeBtns.on("click", function () {
    const $removeBtn = $(this);

    const action = $removeBtn.attr("data-action");
    const data = {
      articleCode: $removeBtn.attr("data-code"),
      wosid: $removeBtn.attr("data-wosid"),
    };

    $loadingOverlay.removeClass("hidden");
    $.post(action, data).done((url) => {
      setTimeout(() => {
        appendTimestampAndNavigateTo(url);
      }, 500);
    });
  });
}

//

function formValidate() {
  $.validator.addMethod(
    "dateAfter",
    function (value, element, params) {
      if (!/Invalid|NaN/.test(new Date(value))) {
        return new Date(value) > new Date($(params).val());
      }
      return (
        (isNaN(value) && isNaN($(params).val())) ||
        Number(value) > Number($(params).val())
      );
    },
    "Must be after the other date",
  );

  $(".form-validate").each(function () {
    const $form = $(this);
    const $submitBtn = $form.find("button[type=submit]");

    $form.validate({
      errorClass: "invalid",
      errorPlacement: function () {},
      rules: {
        passwordRepeat: {
          equalTo: "#password",
        },
        licenseExpiresOn: {
          dateAfter: "#licenseReleasedOn",
        },
      },
      submitHandler: function (form) {
        $submitBtn.attr("disabled", "disabled");
        form.submit();
      },
    });
  });
}

function formUpload() {
  const $trigger = $("button[data-upload=trigger]");
  if (!$trigger.length) return;
  const $input = $("input[type=file][data-upload=input]");
  const $flag = $("input[type=hidden][data-upload=flag]");
  const inputExts = $input.attr("data-rule-extension").split("|");
  const $placeholder = $("[data-upload=placeholder]");

  $trigger.on("click", function () {
    $input.trigger("click");
  });

  $input.on("change", function () {
    const filename = this.value.replace(/C:\\fakepath\\/i, "");
    $flag.val("true");
    $placeholder.text(filename);

    const validExt = inputExts.some((validExt) =>
      filename.toLowerCase().endsWith(validExt),
    );

    if (validExt) $placeholder.removeClass("text-red-500");
    else $placeholder.addClass("text-red-500");
  });
}

function formRegister() {
  const $form = $(".form-register");
  if (!$form.length) return;

  const $license = $form.find("input[name=license]");
  const $licenseFields = $form.find(".form-register-license-fields");
  $license.on("change", toggleDataActiveOnTrueValue($licenseFields));

  const $company = $form.find("input[name=company]");
  const $companyFields = $form.find(".form-register-company-fields");
  $company.on("change", toggleDataActiveOnTrueValue($companyFields));
}

function formProfile() {
  const $form = $(".form-profile");
  if (!$form.length) return;

  const $passwordShow = $form.find(".form-profile-password-show");
  const $passwordFields = $form.find(".form-profile-password-fields");
  $passwordShow.on("click", function () {
    $passwordShow.remove();
    $passwordFields.removeClass("hidden");
  });

  const $license = $form.find("input[name=license]");
  const $licenseFields = $form.find(".form-profile-license-fields");
  $license.on("change", toggleDataActiveOnTrueValue($licenseFields));

  const $licenseShow = $form.find(".form-profile-license-show");
  $licenseShow.on("click", function () {
    $licenseShow.closest(".form-profile-license-strings").remove();
    $licenseFields
      .attr("data-active", "true")
      .find("input")
      .removeAttr("readonly");
  });
}

function popupHandler() {
  $("a[data-mfp-src]").each(function () {
    $(this).magnificPopup({
      type: "inline",
    });
  });
}

function profileDropdown() {
  const $toggle = $(".profile-dropdown-toggle");
  if (!$toggle.length) return;
  const $menu = $(".profile-dropdown-menu");

  $toggle.on("click", function () {
    $menu.toggleClass("flex hidden");
  });
}

function searchForm() {
  const $toggle = $(".search-form-toggle");
  const $panel = $(".search-form-panel");

  $toggle.on("click", function () {
    $panel.toggleClass("block hidden");
  });
}

function shippingAddressCopy() {
  $(".shipping-address-copy").on("click", function (e) {
    const companyName = $("input[name=companyName]").val();
    const fullName =
      $("input[name=firstName]").val() + " " + $("input[name=lastName]").val();

    $("input[name=shippingName]").val(companyName || fullName);
    $("input[name=shippingStreet]").val($("input[name=billingStreet]").val());
    $("input[name=shippingZipCode]").val($("input[name=billingZipCode]").val());
    $("input[name=shippingCity]").val($("input[name=billingCity]").val());
    $("input[name=shippingProvinceCode").val(
      $("input[name=billingProvinceCode]").val(),
    );
  });
}

//

function paymentHandler() {
  const $checkoutBtn = $("#checkout-btn");
  if (!$checkoutBtn.length) return;

  const wosid = $checkoutBtn.attr("data-wosid");
  // const $body = $("body");
  const $loadingOverlay = $(".checkout-view-loading-overlay");

  $checkoutBtn.on("click", function () {
    // $body.addClass("overflow-hidden");
    $loadingOverlay.removeClass("hidden");

    const createAction = $checkoutBtn.attr("data-action");
    const createRequest = { wosid };
    $.post(createAction, createRequest).done((createResponse) => {
      // console.log(createResponse);
      axerve.lightBox.shop = createResponse.shopLogin;
      axerve.lightBox.open(
        createResponse.paymentID,
        createResponse.paymentToken,
      );

      setTimeout(function () {
        // $body.removeClass("overflow-hidden");
        $loadingOverlay.addClass("hidden");
      }, 1000);
    });
  });
}

//

function appendTimestampAndNavigateTo(url) {
  const ts = new Date().getTime();
  window.location.href = `${url}${url.indexOf("?") < 0 ? "?" : "&"}ts=${ts}`;
}

function toggleDataActiveOnTrueValue($target) {
  return function () {
    const value = $(this).val();
    if (value === "true") {
      $target.attr("data-active", "true");
    } else {
      $target.attr("data-active", "false").find("input, select").val("");
    }
  };
}
